import { t } from 'i18next'
import { setLocale } from 'yup'

const fieldNames = {
  title: () => t('validation.field_names.title'),
  parentGoalId: () => t('validation.field_names.parent_goal_id'),
  category: () => t('validation.field_names.category'),
  locationId: () => t('validation.field_names.location_id'),
  riskId: () => t('validation.field_names.risk_id'),
  deadline: () => t('validation.field_names.deadline'),
  responsibleUser: () => t('validation.field_names.responsible_user'),
  influencingFactorId: () => t('validation.field_names.influencing_factor_id'),
  notes: () => t('validation.field_names.notes'),
  targetValue: () => t('validation.field_names.target_value'),
  targetValueType: () => t('validation.field_names.target_value_type'),
}

const getFieldName = (path: string) => (fieldNames[path] ? fieldNames[path]() : path)

export const configureYup = () => {
  setLocale({
    mixed: {
      required: ({ path }) => t('validation.messages.required', { field: getFieldName(path) }),
      notType: ({ type, path }) => {
        return t('validation.messages.not_type', { field: getFieldName(path), type })
      },
    },
    string: {
      email: () => t('validation.messages.email'),
      min: ({ min, path }) => t('validation.messages.string_min', { field: getFieldName(path), min }),
      max: ({ max, path }) => t('validation.messages.string_max', { field: getFieldName(path), max }),
    },
    number: {
      min: ({ min, path }) => t('validation.messages.number_min', { field: getFieldName(path), min }),
      max: ({ max, path }) => t('validation.messages.number_max', { field: getFieldName(path), max }),
      positive: ({ path }) => t('validation.messages.positive', { field: getFieldName(path) }),
      negative: ({ path }) => t('validation.messages.negative', { field: getFieldName(path) }),
      integer: ({ path }) => t('validation.messages.integer', { field: getFieldName(path) }),
    },
  })
}
